const requireAll = (requireContext) => requireContext.keys().map(requireContext)
const req = require.context('./svg', true, /\.svg$/)

requireAll(req)
